export default __webpack_public_path__ + "static/logo-dark-67a7f6a467aa21bdbef8afa6cbcab97e.svg";